import Collection from 'core/model/Collection';
import CloudExportGcpCustomAppServiceAccount from './CloudExportGcpServiceAccount';

export default class CloudExportGcpCustomAppServiceAccountCollection extends Collection {
  get url() {
    return '/api/ui/cloudExportGcpCustomAppServiceAccount';
  }

  get model() {
    return CloudExportGcpCustomAppServiceAccount;
  }
}
